module.exports = __webpack_public_path__ + "media/images/lalamove-allcare-mobile-e58c32587beb091df6d0a1fdde970cb8.png";